import CheckCircleIcon from '@mui/icons-material/CheckCircle';

export default CheckCircleIcon;
